import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';

// Screens
import Main from './app/Main';
import Login from './screens/login';

// Client Screens
import ClientCampaigns from './screens/client/campaigns';
import ClientCampaignDetail from './screens/client/campaigns/Detail';
import Products from './screens/client/agency/Products';
import ProductDetails from './screens/client/agency/ProductDetails';
import NewRequests from './screens/client/requests/ListRequest';
import Profile from './screens/client/profile';
import AgencyRequests from './screens/client/agency/requests/Edit';
import CreateCampaningsPromoters from './screens/client/trades/campaings/CreateCampaningsPromoters';
import SearchTrades from './screens/client/trades/uniforms/SearchTrades';
import ExchangeOrder from './screens/client/trades/uniforms/ExchangeOrder';
import RequestUniform from './screens/client/trades/uniforms/RequestUniform';
import ClipboardsTrads from './screens/client/trades/clipboards/ClipboardsTrads';
import CampaingnPromoter from './screens/client/trades/campaings/CampaingnPromoter';
import Cart from './screens/client/cart';
import CheckoutTrade from './screens/client/cart/checkoutTrade';
import CheckoutAgencia from './screens/client/cart/checkoutAgencia';
import Dashboard from './screens/client/dashboard';

// Admin Screens
import {
  Communication as AdminDashboardCommunication,
  Trade as AdminDashboardTrade,
  Agency as AdminDashboardAgency,
} from './screens/admin/Dashboard';
import AdminCommunicationCampaignList from './screens/admin/MessagesCampaigns/List';
import AgenciaAndAdminPreRegistration from './screens/admin/PreRegistration/Detail';
import AdminPreRegistration from './screens/admin/PreRegistration/List';
import AdminCommunicationCampaignDetail from './screens/admin/MessagesCampaigns/Detail';
import AgencyRequestsAdmin from './screens/admin/Agency/Requests/Admin/List';
import AgencyRequestsAdminDetail from './components/agency/requests/DetailRequestAgency';
import AgencyRequestsAdminArte from './components/agency/requests/Arts';
// Old Screens
import AdminMessageModelsList from './screens/admin/MessageModels/MessageCampaingsModels';
import AdminCategoryMessageModelsList from './screens/admin/MessageModels/CategorysMessageModels/List';
import AdminCategoryMessageModelsEdit from './screens/admin/MessageModels/CategorysMessageModels/Edit';
// import AdminMessageModelsEdit from './screens/admin/MessageModels/Edit';
import AdminCategoryModelsList from './screens/admin/CategoryModels/CategoryModels';
import AdminCategoryModelsEdit from './screens/admin/CategoryModels/Edit';
import ManageMessageCategories from './screens/admin/MessageModels/ManageMessageCategorys';
import Users from './screens/admin/Users/List';
import UserEdit from './screens/admin/Users/Edit';
import UserRegister from './screens/admin/Users/Register';
import EsqueciSenha from './screens/admin/Users/EsqueciSenha';
import AdminBudgets from './screens/admin/Gestao/Budget/List';
import AdminProducts from './screens/admin/Products/List';
import AdminFornecedor from './screens/admin/Fornecedor/List';
import AdminFornecedorEdit from './screens/admin/Fornecedor/Edit';
import AdminNamesProducts from './screens/admin/Products/ManageNames/List';
import AdminNamesProductsEdit from './screens/admin/Products/ManageNames/Edit';
import AdminSizesProducts from './screens/admin/Products/ManageSizes/List';
import AdminSizesProductsEdit from './screens/admin/Products/ManageSizes/Edit';
import AdminAplicacaoProducts from './screens/admin/Products/ManagementApplication/List';
import AdminAplicacaoProductsEdit from './screens/admin/Products/ManagementApplication/Edit';
import AdminTagsProducts from './screens/admin/Products/ManageTags/List';
import AdminTagsProductsEdit from './screens/admin/Products/ManageTags/Edit';
import AdminDetalhesProducts from './screens/admin/Products/ManagementDetails/List';
import AdminMaterialProducts from './screens/admin/Products/MaterialsManagement/List';
import AdminMaterialProductsEdit from './screens/admin/Products/MaterialsManagement/Edit';
import AdminDetalhesProductsEdit from './screens/admin/Products/ManagementDetails/Edit';
import AdminProductDetail from './screens/admin/Products/Edit';
import AdminProductAgenciaDetail from './screens/admin/Products/Edit/Agencia';
import ManageGroupProducts from './screens/admin/Products/ManageGroups/List';
import ManageGroupProductsEdit from './screens/admin/Products/ManageGroups/Edit';
import AdminBudgetDetail from './screens/admin/Gestao/Budget/Edit';
import AdminGifts from './screens/admin/Trades/Gifts/List';
import AdminGiftsDetail from './screens/admin/Trades/Gifts/Detail';
import AdminGiftsDetailEdit from './screens/admin/Trades/Gifts/Edit';
import AdminUniforms from './screens/admin/Trades/Uniforms/List';
import AdminUniformModelsEdit from './screens/admin/Trades/Uniforms/Detail/Main';
import AdminClipboards from './screens/admin/Trades/Clipboards/List';
import AdminClipboardsModelsEdit from './screens/admin/Trades/Clipboards/Detail/Main';
import AdminCampaignPromoter from './screens/admin/Trades/Campaign/List';
import AdminCampaignPromoterEdit from './screens/admin/Trades/Campaign/Detail/Main';
import BannersDashboard from './screens/admin/Dashboard/BannersDashboard';
import Equipe from './screens/admin/Equipe/List';
import EquipeEdit from './screens/admin/Equipe/Edit';
import Segmentos from './screens/admin/Gestao/Segmentos/List';
import SegmentosEdit from './screens/admin/Gestao/Segmentos/Edit';

// CONFIGS
import { AGENCIA } from './config/turnOnOff';

const App = ({ isAdmin }) => (
  <Router>
    <Main>
      {/* Client Routes */}
      <Route
        path="/"
        render={() => {
          if (isAdmin) {
            const user = JSON.parse(localStorage.getItem('user'));
            const { trade, agencia, comunicacao } = user;
            if (trade) {
              return <Redirect from="/" to="/admin/dashboard/trade" />;
            }
            if (agencia) {
              return <Redirect from="/" to="/admin/dashboard/agencia" />;
            }

            if (comunicacao) {
              return <Redirect from="/" to="/admin/dashboard/comunicacao" />;
            }
          }
          return <Dashboard />;
        }}
        exact
      />
      <Route path="/login" component={Login} exact />
      <Route path="/esqueci-senha" component={EsqueciSenha} exact />
      <Route path="/cadastro" component={UserRegister} exact />
      <Route path="/perfil" component={Profile} />
      <Route path="/comunicacao/campanhas" component={ClientCampaigns} />
      <Route
        path="/comunicacao/campanha/:id"
        component={ClientCampaignDetail}
      />

      <Route
        path="/pedido/comunicacao/campanha/:id"
        component={ClientCampaignDetail}
      />

      <Route path="/trade/brindes/categoria" component={Products} />
      <Route path="/trade/brinde/:id" component={ProductDetails} />
      <Route path="/pedidos/" component={NewRequests} />
      <Route path="/carrinho" component={Cart} exact />
      <Route path="/carrinho/checkout-trade" component={CheckoutTrade} exact />
      <Route
        path="/carrinho/checkout-agencia"
        component={CheckoutAgencia}
        exact
      />
      <Route path="/trade/uniformes" exact component={SearchTrades} />
      <Route
        path="/trade/uniformes/trocar/:id"
        exact
        component={ExchangeOrder}
      />
      <Route
        path="/trade/uniformes/solicitar/:id"
        exact
        component={RequestUniform}
      />
      <Route path="/trade/pranchetas" exact component={ClipboardsTrads} />
      <Route
        path="/trade/campanhas"
        exact
        component={CreateCampaningsPromoters}
      />
      <Route
        path="/trade/campanhas/:name"
        exact
        component={CampaingnPromoter}
      />

      {/* Admin Routes */}
      <Route
        path="/admin/dashboard/comunicacao"
        component={AdminDashboardCommunication}
        exact
      />
      <Route
        path="/admin/dashboard/trade"
        component={AdminDashboardTrade}
        exact
      />
      <Route
        path="/admin/dashboard/agencia"
        component={AdminDashboardAgency}
        exact
      />
      <Route path="/admin/usuarios/lista" component={Users} />
      <Route path="/admin/banner-dashboard" component={BannersDashboard} />
      <Route path="/admin/usuario/:id" component={UserEdit} />
      <Route path="/admin/Equipes/lista" component={Equipe} />
      <Route path="/admin/Equipe/:id" component={EquipeEdit} />
      <Route
        path="/admin/comunicacao/campanhas"
        component={AdminCommunicationCampaignList}
      />
      <Route
        path="/admin/comunicacao/campanha/:id"
        component={AdminCommunicationCampaignDetail}
      />
      <Route
        path="/admin/modelos-mensagem/lista"
        component={AdminMessageModelsList}
      />
      <Route
        path="/admin/modelos-mensagem/categorias"
        component={AdminCategoryMessageModelsList}
      />

      <Route
        path="/admin/modelos-mensagem/categoria/sac/criar"
        component={AdminCategoryMessageModelsEdit}
        exact
      />
      <Route
        path="/admin/modelos-mensagem/categoria/mensagem/criar"
        component={AdminCategoryMessageModelsEdit}
        exact
      />

      <Route
        path="/admin/modelos-mensagem/categoria/sac/editar/:id"
        component={AdminCategoryMessageModelsEdit}
        exact
      />
      <Route
        path="/admin/modelos-mensagem/categoria/mensagem/editar/:id"
        component={AdminCategoryMessageModelsEdit}
        exact
      />
      <Route
        path="/admin/modelos-mensagem/editar/:id"
        component={ManageMessageCategories}
        exact
      />
      <Route
        path="/admin/modelos-mensagem/criar/:type"
        component={ManageMessageCategories}
        exact
      />
      <Route
        path="/admin/modelos-categorias"
        component={AdminCategoryModelsList}
      />
      <Route
        path="/admin/modelos-categorias/editar/:id"
        component={AdminCategoryModelsEdit}
      />
      <Route
        path="/admin/modelos-categorias/criar"
        component={AdminCategoryModelsEdit}
      />
      <Route path="/trade/admin/uniformes/lista" component={AdminUniforms} />
      <Route
        path="/trade/admin/uniformes/editar/:id"
        component={AdminUniformModelsEdit}
        exact
      />
      <Route path="/admin/produtos" component={AdminProducts} />
      <Route path="/admin/produto/:id" component={AdminProductDetail} />
      <Route
        path="/admin/produto-agencia/:id"
        component={AdminProductAgenciaDetail}
      />
      <Route path="/admin/fornecedores" component={AdminFornecedor} />
      <Route path="/admin/fornecedor/:id" component={AdminFornecedorEdit} />
      <Route
        exact
        path="/admin/nomes/produtos"
        component={AdminNamesProducts}
      />
      <Route
        exact
        path="/admin/nome/produto/editar"
        component={AdminNamesProductsEdit}
      />
      <Route
        exact
        path="/admin/nome/produto/editar/:id"
        component={AdminNamesProductsEdit}
      />

      <Route
        exact
        path="/admin/materiais/produtos"
        component={AdminMaterialProducts}
      />
      <Route
        exact
        path="/admin/material/produto/editar"
        component={AdminMaterialProductsEdit}
      />
      <Route
        exact
        path="/admin/material/produto/editar/:id"
        component={AdminMaterialProductsEdit}
      />

      <Route
        exact
        path="/admin/tamanhos/produtos"
        component={AdminSizesProducts}
      />
      <Route
        exact
        path="/admin/tamanho/produto/editar"
        component={AdminSizesProductsEdit}
      />
      <Route
        exact
        path="/admin/tamanho/produto/editar/:id"
        component={AdminSizesProductsEdit}
      />
      <Route
        exact
        path="/admin/detalhes/produtos"
        component={AdminDetalhesProducts}
      />
      <Route
        exact
        path="/admin/detalhe/produto/editar"
        component={AdminDetalhesProductsEdit}
      />
      <Route
        exact
        path="/admin/detalhe/produto/editar/:id"
        component={AdminDetalhesProductsEdit}
      />

      <Route
        exact
        path="/admin/aplicacoes/produtos"
        component={AdminAplicacaoProducts}
      />
      <Route
        exact
        path="/admin/aplicacao/produto/editar"
        component={AdminAplicacaoProductsEdit}
      />
      <Route
        exact
        path="/admin/aplicacao/produto/editar/:id"
        component={AdminAplicacaoProductsEdit}
      />

      <Route exact path="/admin/tags/produtos" component={AdminTagsProducts} />
      <Route
        exact
        path="/admin/tags/produto/editar"
        component={AdminTagsProductsEdit}
      />
      <Route
        exact
        path="/admin/tags/produto/editar/:id"
        component={AdminTagsProductsEdit}
      />

      <Route
        exact
        path="/admin/grupos/produtos"
        component={ManageGroupProducts}
      />
      <Route
        exact
        path="/admin/grupo/produtos/editar"
        component={ManageGroupProductsEdit}
      />
      <Route
        exact
        path="/admin/grupo/produtos/editar/:id"
        component={ManageGroupProductsEdit}
      />

      <Route
        exact
        path="/admin/categorias/produtos"
        component={ManageGroupProducts}
      />
      <Route
        exact
        path="/admin/categoria/produtos/editar"
        component={ManageGroupProductsEdit}
      />
      <Route
        exact
        path="/admin/categoria/produtos/editar/:id"
        component={ManageGroupProductsEdit}
      />

      <Route path="/admin/gestao/budgets" component={AdminBudgets} />
      <Route path="/admin/gestao/budget/:id" component={AdminBudgetDetail} />
      <Route path="/admin/trade/brindes" component={AdminGifts} />
      <Route path="/admin/trade/brinde/:id" component={AdminGiftsDetail} />
      <Route
        path="/admin/trade/brinde-detalhe/:id"
        component={AdminGiftsDetailEdit}
      />
      <Route path="/trade/admin/pranchetas/lista" component={AdminClipboards} />
      <Route
        path="/trade/admin/pranchetas/editar/:id"
        component={AdminClipboardsModelsEdit}
        exact
      />
      <Route
        path="/trade/admin/campanhas-promocionais/lista"
        component={AdminCampaignPromoter}
      />
      <Route
        path="/trade/admin/campanhas-promocionais/editar/:id"
        component={AdminCampaignPromoterEdit}
        exact
      />

      <Route
        path="/trade/campanhas-promocionais/visualizar/:id"
        component={AdminCampaignPromoterEdit}
        exact
      />

      {AGENCIA.loja && (
        <Route
          path="/agencia/pre-cadastro"
          component={AgenciaAndAdminPreRegistration}
          exact
        />
      )}

      <Route path="/admin/pre-cadastros" component={AdminPreRegistration} />

      <Route
        path="/admin/pre-cadastro/:id"
        component={AgenciaAndAdminPreRegistration}
        exact
      />
      <Route
        path="/pre-cadastro/:id"
        component={AgenciaAndAdminPreRegistration}
        exact
      />
      <Route path="/agencia/grupo/:id" component={AgencyRequests} exact />
      <Route path="/agencia/grupo/:id/:subId" component={AgencyRequests} exact />
      <Route path="/agencia/pedido/:id" component={AgencyRequests} exact />
      <Route path="/admin/agencia/pedidos" component={AgencyRequestsAdmin} />

      <Route
        path="/admin/agencia/pedido/:id"
        component={AgencyRequestsAdminDetail}
      />

      <Route
        path="/admin/agencia/arte-pedido/:idPedido/:id"
        component={AgencyRequestsAdminArte}
      />

      <Route
        exact
        path="/admin/gestao/segmentos/"
        component={Segmentos}
      />
      <Route
        exact
        path="/admin/gestao/segmentos/editar"
        component={SegmentosEdit}
      />
      <Route
        exact
        path="/admin/gestao/segmentos/editar/:id"
        component={SegmentosEdit}
      />

    </Main>
  </Router>
);

const mapStateToProps = state => ({
  isAdmin: state.main.showAdminMenu
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js